export default function alertsDirective(Alerts) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {
      alerts: '=',
    },
    template: `<alert ng-repeat="alert in alerts track by alert.id" alert="alert" close="close"></alert>`,
    link: function ($scope) {
      $scope.close = function (id) {
        Alerts.remove(id);
      };
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/alerts/alerts.directive.js
 **/